import type { FC } from 'react'
import { useState } from 'react'

import { useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import queries from '@/api/queries'
import systemMessagesResources from '@/api/system-messages'
import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import { getFromLocalStorage } from '@/util/persistance'

import Page from '../content/Page'

import SystemMessage from './SystemMessage'

import './all-system-messages.scss'

dayjs.extend(relativeTime)

const AllSystemMessagesPage: FC = () => {
  const { locale } = useAppContext()

  const [seenMessages, setSeenMessages] = useState<number[] | undefined>(
    getFromLocalStorage('read-system-messages')
  )

  const { data } = useQuery(queries.systemMessages(), systemMessagesResources.getList)
  const messageList = data?.filter(message => message.locale === locale) || []

  return (
    // todo: refactor Page component
    // @ts-ignore
    <Page className="all-system-messages-page">
      <h1>
        <Translation id="Notifications" />
      </h1>

      {messageList.map(message => (
        <div key={message.id} className="system-message-tile">
          <SystemMessage
            maxTextHeight={99999}
            seenMessages={seenMessages}
            {...message}
            onSeenMessagesSet={setSeenMessages}
          />

          <div className="divider" />
        </div>
      ))}
    </Page>
  )
}

export default AllSystemMessagesPage
